import i18next from "i18next";

const normalizeLocale = (locale?: string | null) => locale?.replace(/_/g, "-").toLowerCase() || undefined;

let currentCurrencyLocale: string | undefined;

export const getCurrencyLocale = () =>
    currentCurrencyLocale ?? normalizeLocale(i18next.resolvedLanguage || i18next.language) ?? "en";

export const setCurrencyLocale = (locale?: string | null) => {
    currentCurrencyLocale = normalizeLocale(locale);
};

